import { useEffect } from 'react';
import { useMap, useMapEvents } from 'react-leaflet';

interface MapInstanceCaptureProps {
  onMapReady: (map: any) => void;
  onZoomChange?: (zoom: number) => void;
}

/**
 * Component to capture the Leaflet map instance and track zoom changes
 * Uses react-leaflet's useMap hook to get the map reference
 * Listens to zoom events to update the zoom level in the parent component
 */
export const MapInstanceCapture: React.FC<MapInstanceCaptureProps> = ({
  onMapReady,
  onZoomChange
}) => {
  const map = useMap();

  // Listen to zoom events
  useMapEvents({
    zoomend: () => {
      if (onZoomChange) {
        const currentZoom = map.getZoom();
        onZoomChange(currentZoom);
      }
    },
  });

  useEffect(() => {
    onMapReady(map);
    // Also set initial zoom
    if (onZoomChange) {
      const initialZoom = map.getZoom();
      onZoomChange(initialZoom);
    }
  }, [map, onMapReady, onZoomChange]);

  return null;
};
